var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"marquee",staticClass:"marquee"},[_c('span',{ref:"marqueeText",style:({ animationDuration: _vm.durationSec + 's', })},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }